module.exports = __webpack_public_path__ + "static/media/icon-send.a5fa82f5.svg";